import VueI18n from "../utils/languages/index"
export default {
  defaultLanguage: 'zh-CN',
  navData: [
    {
      id: 1,
      key: '1',
      name: VueI18n.t('acm_home'),
      href: '/index',
      disabled: false,
      external: false,
      child: []
    },
    {
      id: 2,
      key: '2',
      name: VueI18n.t('acm_about_us'),
      href: '/about',
      disabled: false,
      external: false,
      child: []
    },
    {
      id: 3,
      key: '3',
      name: VueI18n.t('acm_product_service'),
      href: '/service',
      disabled: false,
      external: false,
      child: []
    },

    {
      id: 5,
      key: '5',
      name: VueI18n.t('acm_login_acm'),
      // href: '/news',
      href: 'https://login.acapman.com',
      disabled: false,
      external: true,
      child: []
    }
  ],
  welcomeData: {
    title: VueI18n.t('acm_welcome_acm'),
    titleEn: 'WELCOME TO ACM.',
    text: VueI18n.t('acm_welcome_info')
  },
  unlockData: {
    title: VueI18n.t('acm_open_unlimited_foreign_trading'),
    titleEn: 'UNLOCK THE UNLIMITED POSSIBILITIES OF FOREX TRADING',
    list: [
      {
        id: 0,
        title: VueI18n.t('acm_forex_trading_title_1'),
        text: VueI18n.t('acm_forex_trading_info_1'),
        img: require('@/assets/home-bg4-1.png')
      },
      {
        id: 1,
        title: VueI18n.t('acm_forex_trading_title_3'),
        text: VueI18n.t('acm_forex_trading_info_3'),
        img: require('@/assets/home-bg4-2.png')
      },
      {
        id: 2,
        title: VueI18n.t('acm_forex_trading_title_2'),
        text: VueI18n.t('acm_forex_trading_info_2'),
        img: require('@/assets/home-bg4-3.png')
      },
      {
        id: 3,
        title: VueI18n.t('acm_forex_trading_title_4'),
        text: VueI18n.t('acm_sha_forex_trading_info_4'),
        img: require('@/assets/home-bg4-4.png')
      }
    ]
  },
  creditData: {
    title: VueI18n.t('acm_acm_world_first_credit_line'),
    titleEn: 'ACM\' PIONEERING 1:1 LOAN CREDIT MODEL',
    text: VueI18n.t('acm_acm_credit_limit_info'),
    img: require('@/assets/home-bg5.png'),
    imgM: require('@/assets/home-bg5-m.png')
  },
  newData: {
    title: VueI18n.t('acm_acm_news_center'),
    titleEn: 'ACM NEWS CENTER',
    list: [
      {
        id: 0,
        img: require('@/assets/home-bg6-1.png'),
        title: VueI18n.t('这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题'),
        coontent: VueI18n.t('这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容'),
        time: '2025-01-07'
      },
      {
        id: 1,
        img: require('@/assets/home-bg6-2.png'),
        title: VueI18n.t('这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题'),
        coontent: VueI18n.t('这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容'),
        time: '2025-01-07'
      },
      {
        id: 2,
        img: require('@/assets/home-bg6-3.png'),
        title: VueI18n.t('这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题'),
        coontent: VueI18n.t('这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容'),
        time: '2025-01-07'
      },
      {
        id: 3,
        img: require('@/assets/home-bg6-4.png'),
        title: VueI18n.t('这是标题这是标题这是标题这是标题这是标题这是标题这是标题这是标题'),
        coontent: VueI18n.t('这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容这是内容'),
        time: '2025-01-07'
      }
    ]
  },
  structureData: {
    title: VueI18n.t('acm_acm_business_architecture'),
    titleEn: 'ACM BUSINESS STRUCTURE',
    list: [
      {
        id: 0,
        name: VueI18n.t('acm_forex_trading_title_2'),
        img: require('@/assets/htfx-logo.png')
      },
      {
        id: 1,
        name: VueI18n.t('acm_forex_trading_title_3'),
        img: require('@/assets/sh-logo.png')
      }
    ]
  },
  backgroundData: {
    title: VueI18n.t('acm_acm_background'),
    titleEn: 'ACM BACKGROUND',
    info: VueI18n.t('acm_background_info'),
    textTitle: VueI18n.t('acm_building_bridge_connect'),
    textInfo: VueI18n.t('acm_building_bridge_connect_info'),
  },
  shData: {
    title1: VueI18n.t('acm_sh_placards_1'),
    title2: VueI18n.t('acm_sh_placards_2'),
    titleEn1: 'ONE LIFE, ONE FOCUS',
    titleEn2: 'DECODING FINANCIAL CODE',
    text: VueI18n.t('acm_sh_info')
  },
  coreData: {
    list: [
      {
        id: 0,
        title: VueI18n.t('acm_core_value'),
        text: VueI18n.t('acm_crux_info_1')
      },
      {
        id: 1,
        title: VueI18n.t('acm_mission'),
        text: VueI18n.t('acm_crux_info_2')
      },
      {
        id: 2,
        title: VueI18n.t('acm_online_academy'),
        text: VueI18n.t('acm_crux_info_3')
      },
      {
        id: 3,
        title: VueI18n.t('acm_private_meeting'),
        text: VueI18n.t('acm_crux_info_4')
      }
    ]
  },
  processData: {
    title: VueI18n.t('acm_transaction_order_formation_process'),
    titleEn: 'TRANSACTION ORDERFORMATIONPROCESS',
    list: [
      {
        id: 1,
        icon: require('@/assets/service-icon1.png'),
        name: VueI18n.t('acm_individual_users')
      },
      {
        id: 2,
        icon: require('@/assets/service-icon2.png'),
        name: VueI18n.t('acm_acm')
      },
      {
        id: 3,
        icon: require('@/assets/service-icon3.png'),
        name: VueI18n.t('acm_principal_brokerage_firm')
      },
      {
        id: 4,
        icon: require('@/assets/service-icon4.png'),
        name: VueI18n.t('acm_partner_traffic_providers')
      }
    ],
    text: VueI18n.t('acm_subscriber_protection_info')
  },
  introduceData: {
    title: VueI18n.t('acm_create_new_model'),
    titleEn: 'INTRODUCING THE ALL-NEW CONSOLIDATION MODULE',
    text: VueI18n.t('acm_comparison_traditional_modes'),
    tableLable: [
      {
        id: 1,
        label: '',
        name: 'title'
      },
      {
        id: 2,
        label: VueI18n.t('acm_traditional_modes'),
        name: 'traditional'
      },
      {
        id: 3,
        label: VueI18n.t('acm_acm_c_modes'),
        name: 'consolidation'
      }
    ],
    tableData: [
      {
        id: 1,
        title: VueI18n.t('acm_contrast_1'),
        traditional: VueI18n.t('acm_traditional_contrast_1'),
        consolidation: VueI18n.t('acm_c_modes_contrast_1')
      },
      {
        id: 2,
        title: VueI18n.t('acm_contrast_2'),
        traditional: VueI18n.t('acm_traditional_contrast_2'),
        consolidation: VueI18n.t('acm_c_modes_contrast_2')
      },
      {
        id: 3,
        title: VueI18n.t('acm_contrast_3'),
        traditional: VueI18n.t('acm_traditional_contrast_3'),
        consolidation: VueI18n.t('acm_c_modes_contrast_3')
      },
      {
        id: 4,
        title: VueI18n.t('acm_contrast_4'),
        traditional: VueI18n.t('acm_traditional_contrast_4'),
        consolidation: VueI18n.t('acm_c_modes_contrast_4')
      },
      {
        id: 5,
        title: VueI18n.t('acm_contrast_5'),
        traditional: VueI18n.t('acm_traditional_contrast_5'),
        consolidation: VueI18n.t('acm_c_modes_contrast_5')
      }
    ]
  },
  intelligentData: {
    title: VueI18n.t('acm_sha_intelligent_trading_system'),
    titleEn: 'SHA INTELLIGENT TRADING SYSTEM',
    text: VueI18n.t('acm_sha_intelligent_trading_system_info'),
    model: {
      title: VueI18n.t('acm_mental_model'),
      text: VueI18n.t('acm_judgmental_decision'),
      list: [
        {
          id: 1,
          title: VueI18n.t('acm_monte_carlo_algorithm'),
          text: VueI18n.t('acm_monte_carlo_algorithm_info'),
          img: require('../assets/service-bg2.png')
        },
        {
          id: 2,
          title: VueI18n.t('acm_deep_neural_network_model'),
          text: VueI18n.t('acm_deep_neural_network_model_info'),
          img: require('../assets/service-bg3.png')
        }
      ],
    },
    strategy: {
      title: VueI18n.t('acm_hex_trading_strategy'),
      text: VueI18n.t('acm_execution_transactions'),
      list: [
        {
          id: 1,
          name: VueI18n.t('acm_trading_strategy_1'),
        },
        {
          id: 2,
          name: VueI18n.t('acm_trading_strategy_2'),
        },
        {
          id: 3,
          name: VueI18n.t('acm_trading_strategy_3'),
        },
        {
          id: 4,
          name: VueI18n.t('acm_trading_strategy_4'),
        },
        {
          id: 5,
          name: VueI18n.t('acm_trading_strategy_5'),
        },
        {
          id: 6,
          name: VueI18n.t('acm_trading_strategy_6'),
        }
      ],
    }
  },
  advantagesData: {
    title: VueI18n.t('acm_sha_advantages'),
    titleEn: 'ADVANTAGES OF INTELLIGENT TRADING SYSTEN',
    list: [
      {
        id: 1,
        text: VueI18n.t('acm_sha_advantages_info_1')
      },
      {
        id: 2,
        text: VueI18n.t('acm_sha_advantages_info_2')
      },
      {
        id: 3,
        text: VueI18n.t('acm_sha_advantages_info_3')
      },
      {
        id: 4,
        text: VueI18n.t('acm_sha_advantages_info_4')
      },
      {
        id: 5,
        text: VueI18n.t('acm_sha_advantages_info_5')
      },
      {
        id: 6,
        text: VueI18n.t('acm_sha_advantages_info_6')
      }
    ]
  },
  bottomsData: {
    title: VueI18n.t('acm_contact_s'),
    titleEn: 'CONTACT US.',
    contactDetails: VueI18n.t('acm_email'),
    contactDetailsUrl: 'support@acapman.com',
    placards: VueI18n.t('acm_placards'),
    placardsEn: 'CRACK THE FINANCIAL CODE AND EMBARK ON THE JOURNEY OF WEALTH APPRECIATION.'
  }
}